module.exports = __webpack_public_path__ + "static/media/MCT_REAL_neg.8d965b4c.png";